// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + "@atlaskit-internal_Tooltip" + "." + "b5ef286e" + ".chunk.js";
};